/**
 * Microsoft's four-square mark: the sign-in button, and the Users table's Sign-in column. Its own
 * colours, which are Microsoft's and not Aura's palette. `animated` sweeps the squares while the
 * sign-in button is leaving for Microsoft.
 */
export function MicrosoftMark({ animated = false, className }: { animated?: boolean; className?: string }) {
  const squares = [
    { x: 1, y: 1, fill: "#F25022" },
    { x: 10.5, y: 1, fill: "#7FBA00" },
    { x: 1, y: 10.5, fill: "#00A4EF" },
    { x: 10.5, y: 10.5, fill: "#FFB900" },
  ];
  const order = [0, 1, 3, 2];
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden className={className ?? "size-4.5 shrink-0"}>
      {squares.map((sq, i) => (
        <rect
          key={sq.fill}
          x={sq.x}
          y={sq.y}
          width="8.5"
          height="8.5"
          fill={sq.fill}
          className={animated ? "aura-signin-square" : undefined}
          style={animated ? { animationDelay: `${order.indexOf(i) * 0.35}s` } : undefined}
        />
      ))}
    </svg>
  );
}
